"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledComboboxOption = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ComboboxOptionMixin = require("../../mixins/components/ComboboxOptionMixin");
var _ListboxOption = require("../ListboxOption/ListboxOption");
var StyledComboboxOption = /*#__PURE__*/(0, _styledComponents.default)(_ListboxOption.ListboxOption).withConfig({
  displayName: "StyledComboboxOption",
  componentId: "c11n-8-107-0__sc-38afw7-0"
})(["", ""], _ComboboxOptionMixin.ComboboxOptionMixin);
exports.StyledComboboxOption = StyledComboboxOption;